if(!customElements.get("product-description")) {
  customElements.define("product-description", class ProductDescription extends HTMLElement {
    constructor() {
      super();

      this.headers = this.querySelectorAll("h5");
      this.contents = this.querySelectorAll("ul");

      console.log("header and contents", this.headers, this.contents);
      this.init();
    }

    init() {
      this.headers.forEach((header, index) => {
        header.classList.add("desc-title");
        header.classList.add("desc-title-"+index);
        header.addEventListener("click", this.descriptionClick.bind(this, header));
      });
      this.contents.forEach(content => content.classList.add("desc-content"));
    }

    descriptionClick(header) {
      header.classList.toggle("opened");
    }
  });
}
